import './navigationComponent.scss';
import {ILocationService, IScope} from "angular";
import {NavigationAccessRoles, NavigationItem} from "../../model/navigationItem";
import {PageTitleService} from "../../service/page-title.service";
import {PageTitleServiceName} from "modules/utils/names/serviceNames";
import {CONFIGURATION_INITIALIZER} from "initializers/ActiveBrandInitializer";
import {USER_AUTHORITY_SERVICE} from "main";

export interface NavigationComponentScope extends IScope {
    getNavigationMenuStyle: any;
    userNavigationItems: NavigationItem[];
    adminNavigationItems: NavigationItem[];
    settingsNavigationItem: NavigationItem[];
    toggleAdminNavigation: ($event: MouseEvent) => void;
    toggleSettingsNavigation: ($event: MouseEvent) => void;
    adminNavigationsIsShown: boolean;
    settingsNavigationIsOpen: boolean;
}

export class NavigationComponent {
    private navigationItems: NavigationItem[];

    static instance = {
        template: require('./navigationComponent.html'),
        controller: ['$scope', '$location', PageTitleServiceName, NavigationComponent],
    };

    constructor(private $scope: NavigationComponentScope,
                $location: ILocationService,
                private titleService: PageTitleService) {

        this.navigationItems = USER_AUTHORITY_SERVICE.getPermittedModulesNavigationItems();
        $scope.settingsNavigationItem = USER_AUTHORITY_SERVICE.getUserSettingsItems();

        $scope.userNavigationItems = this.navigationItems
            .filter(ni => ni.accessRole.includes(NavigationAccessRoles.ROLE_USER));

        $scope.adminNavigationItems = this.navigationItems
            .filter(ni => ni.accessRole.includes(NavigationAccessRoles.ROLE_ADMIN));

        $scope.toggleAdminNavigation = this.toggleAdminNavigation;
        $scope.toggleSettingsNavigation = this.toggleSettingsNavigation;

        $scope.adminNavigationsIsShown = true;
        $scope.settingsNavigationIsOpen = false;
        this.subscribeOnRouteChange($scope);
        this.updateTabStatus($location.path());
        this.$scope.getNavigationMenuStyle = this.getNavigationMenuStyle;
    }

    private subscribeOnRouteChange($scope: NavigationComponentScope) {
        $scope.$on('$routeChangeStart', ($event, next, current) => {
                if (next.$$route) {
                    this.updateTabStatus(next.$$route.originalPath);
                } else {
                    //user entered the user that is not being handled and is being redirected
                    this.updateTabStatus("/customers")
                }
            }
        );
    }


    toggleAdminNavigation = ($event: MouseEvent) => {
        this.$scope.adminNavigationsIsShown = !this.$scope.adminNavigationsIsShown;
    };

    toggleSettingsNavigation = ($event: MouseEvent) => {
        this.$scope.settingsNavigationIsOpen = !this.$scope.settingsNavigationIsOpen;
    };

    updateTabStatus(routeName) {
        routeName = routeName.split('/');
        this.navigationItems.forEach(ni => {
            ni.active = ni.checkFunction(routeName);
            if (ni.active) {
                this.titleService.currentTitle = {name: ni.module.title};
            }
        });
    }

    getNavigationMenuStyle = (navigationItem) => {
        let principle = CONFIGURATION_INITIALIZER.assertResolvedAndGetPrinciple();
        return navigationItem.active ? {"border-left": `3px solid ${principle.mainHeaderColor}`} : "";
    };

}

